import { FilterSearch } from '../filter-search.model';

export class ApproveCarriersListFilters {
  public static filterSearch: FilterSearch = {
    filterSearchValue: '',
  };
}
